<mat-dialog-content>
    <mat-spinner></mat-spinner>
</mat-dialog-content>
